/**
 * Frontend mirror of payslip template catalog (tags, sections, layout meta).
 */
export const MERGE_TAGS = [
  {
    group: "Company",
    tags: [
      { key: "{{company_logo}}", label: "Company logo", mapsTo: "showLogo" },
      { key: "{{company_name}}", label: "Company name", mapsTo: "showCompanyName" },
      { key: "{{company_address}}", label: "Company address", mapsTo: "showCompanyAddress" },
      { key: "{{company_pan}}", label: "Company PAN", mapsTo: "showCompanyStatutory" },
      { key: "{{company_tan}}", label: "Company TAN", mapsTo: "showCompanyStatutory" },
      { key: "{{company_pf_code}}", label: "Company PF code", mapsTo: "showCompanyStatutory" },
      { key: "{{company_esi_code}}", label: "Company ESI code", mapsTo: "showCompanyStatutory" },
    ],
  },
  {
    group: "Employee",
    tags: [
      { key: "{{employee_name}}", label: "Employee name", mapsTo: "showEmployeeBasic" },
      { key: "{{employee_code}}", label: "Employee code", mapsTo: "showEmployeeBasic" },
      { key: "{{joining_date}}", label: "Date of joining", mapsTo: "showEmployeeBasic" },
      { key: "{{designation}}", label: "Designation", mapsTo: "showEmployeeMasters" },
      { key: "{{department}}", label: "Department", mapsTo: "showEmployeeMasters" },
      { key: "{{branch}}", label: "Branch / location", mapsTo: "showEmployeeMasters" },
      { key: "{{pan}}", label: "Employee PAN", mapsTo: "showEmployeeStatutory" },
      { key: "{{uan}}", label: "UAN", mapsTo: "showEmployeeStatutory" },
      { key: "{{esi_ip}}", label: "ESI IP", mapsTo: "showEmployeeStatutory" },
      { key: "{{pf_account}}", label: "PF account", mapsTo: "showEmployeeStatutory" },
      { key: "{{bank_name}}", label: "Bank name", mapsTo: "showBankDetails" },
      { key: "{{bank_account}}", label: "Bank account", mapsTo: "showBankDetails" },
      { key: "{{ifsc}}", label: "IFSC", mapsTo: "showBankDetails" },
    ],
  },
  {
    group: "Pay & CTC",
    tags: [
      { key: "{{pay_month}}", label: "Pay month", mapsTo: "showPayPeriod" },
      { key: "{{structure_name}}", label: "Salary structure", mapsTo: "showStructure" },
      { key: "{{annual_ctc}}", label: "Annual CTC", mapsTo: "showAnnualCtc" },
      { key: "{{monthly_ctc}}", label: "Monthly CTC", mapsTo: "showMonthlyCtc" },
      { key: "{{gross_pay}}", label: "Gross pay", mapsTo: "showComponents" },
      { key: "{{total_deductions}}", label: "Total deductions", mapsTo: "showComponents" },
      { key: "{{net_pay}}", label: "Net pay", mapsTo: null },
      { key: "{{net_pay_words}}", label: "Net pay in words", mapsTo: "showNetInWords" },
      { key: "{{paid_days}}", label: "Paid days", mapsTo: "showAttendance" },
      { key: "{{lop_days}}", label: "LOP days", mapsTo: "showAttendance" },
      { key: "{{leave_summary}}", label: "Leave summary", mapsTo: "showLeave" },
    ],
  },
  {
    group: "Reimbursement / Flexi",
    tags: [
      { key: "{{reimbursement_summary}}", label: "Reimbursement summary block", mapsTo: "showReimbursement" },
      { key: "{{reimbursement_paid}}", label: "Reimbursement paid (month)", mapsTo: "showReimbursement" },
      { key: "{{reimbursement_taxable}}", label: "Taxable reimbursement (month)", mapsTo: "showReimbursement" },
      { key: "{{reimbursement_exempt}}", label: "Non-taxable reimbursement (month)", mapsTo: "showReimbursement" },
    ],
  },
  {
    group: "Tax & statutory",
    tags: [
      { key: "{{tds_amount}}", label: "TDS this month", mapsTo: "showTaxDetails" },
      { key: "{{tax_computation}}", label: "Detailed tax computation", mapsTo: "showTaxComputation" },
      { key: "{{ytd_gross}}", label: "YTD gross", mapsTo: "showYtd" },
      { key: "{{ytd_tds}}", label: "YTD TDS", mapsTo: "showYtd" },
      { key: "{{pf_employee}}", label: "PF (employee)", mapsTo: "showStatutory" },
      { key: "{{esi}}", label: "ESI", mapsTo: "showStatutory" },
      { key: "{{pt}}", label: "Professional tax", mapsTo: "showStatutory" },
    ],
  },
];

export const SECTION_BLOCKS = [
  { id: "header", label: "Company header", hint: "Logo, name, address, statutory IDs" },
  { id: "pay_period", label: "Pay period banner", hint: "Payslip for Month-Year" },
  { id: "employee", label: "Employee details", hint: "Basics, masters, statutory, bank" },
  { id: "structure_ctc", label: "Structure & CTC", hint: "Structure name, annual & monthly CTC" },
  { id: "attendance", label: "Attendance summary", hint: "Calendar / paid / LOP days" },
  { id: "leave", label: "Leave details", hint: "Leave taken / balances" },
  { id: "earnings", label: "Earnings", hint: "Earning components (+ optional groups)" },
  { id: "deductions", label: "Deductions", hint: "Deduction components" },
  {
    id: "non_payroll",
    label: "Non-payroll / other",
    hint: "Non-payroll lines (NPS employer, meal voucher, notional) — not in Gross/Net",
  },
  {
    id: "reimbursement",
    label: "Reimbursement / Flexi",
    hint: "Flexi claim payments, taxable vs exempt split for the pay month",
  },
  { id: "statutory", label: "Statutory highlight", hint: "PF / ESI / PT callouts" },
  { id: "tax_summary", label: "Tax / TDS summary", hint: "Month TDS line" },
  {
    id: "tax_computation",
    label: "Detailed tax computation",
    hint: "Regime, taxable income, base tax, rebate, cess, monthly TDS",
  },
  { id: "ytd", label: "YTD totals", hint: "Year-to-date gross / TDS" },
  { id: "net", label: "Net pay", hint: "Net amount (+ words)" },
  { id: "footer", label: "Footer", hint: "Disclaimer / footer text" },
];

export const PAYSLIP_STYLE_TAGS = [
  {
    group: "Company header",
    tags: [
      { key: "showLogo", label: "Company logo", hint: "From Configuration → Enterprise" },
      { key: "showCompanyName", label: "Company name", hint: "Legal / trade name" },
      { key: "showCompanyAddress", label: "Company address", hint: "Registered address" },
      {
        key: "showCompanyStatutory",
        label: "Company statutory IDs",
        hint: "PAN, TAN, PF, ESI codes",
      },
    ],
  },
  {
    group: "Employee details",
    tags: [
      { key: "showEmployeeBasic", label: "Basic employee details", hint: "Name, code, DOJ" },
      {
        key: "showEmployeeMasters",
        label: "Org masters",
        hint: "Department, designation, branch",
      },
      {
        key: "showEmployeeStatutory",
        label: "Employee statutory",
        hint: "PAN, UAN, ESI IP, PF",
      },
      { key: "showBankDetails", label: "Bank details", hint: "Bank, account, IFSC" },
    ],
  },
  {
    group: "Pay, CTC & components",
    tags: [
      { key: "showPayPeriod", label: "Pay period", hint: "Month / year banner" },
      { key: "showStructure", label: "Salary structure name", hint: "Structure label" },
      { key: "showAnnualCtc", label: "Annual CTC", hint: "Total annual CTC capture" },
      { key: "showMonthlyCtc", label: "Monthly CTC", hint: "Monthly CTC capture" },
      { key: "showComponents", label: "Earnings & deductions", hint: "Component lines" },
      {
        key: "showNonPayroll",
        label: "Non-payroll / other section",
        hint: "Show Non-payroll lines (not in Gross) on payslip",
      },
      {
        key: "showReimbursement",
        label: "Reimbursement / Flexi summary",
        hint: "Flexi claim lines paid this month with taxable / non-taxable split",
      },
      {
        key: "groupEarningsByCategory",
        label: "Group earnings by category",
        hint: "Group component lines under category headers",
      },
      { key: "showAttendance", label: "Attendance summary", hint: "Paid days, LOP" },
      { key: "showLeave", label: "Leave details", hint: "Leave summary" },
      { key: "showTaxDetails", label: "Tax / TDS summary", hint: "Month TDS amount" },
      {
        key: "showTaxComputation",
        label: "Detailed tax computation",
        hint: "Summarised annual tax computation block",
      },
      { key: "showStatutory", label: "Statutory highlight", hint: "PF / ESI / PT" },
      { key: "showYtd", label: "YTD totals", hint: "YTD gross / TDS" },
      { key: "showNetInWords", label: "Net pay in words", hint: "Amount in words" },
    ],
  },
];

export const LAYOUT_META = {
  classic: {
    title: "Classic",
    blurb: "Standard Indian payslip — company, employee, CTC, earnings, deductions, net",
  },
  compact: {
    title: "Compact",
    blurb: "Dense one-page slip — essentials only",
  },
  detailed: {
    title: "Detailed",
    blurb: "Full masters, grouped earnings, leave, tax computation & YTD",
  },
  statutory: {
    title: "Statutory-heavy",
    blurb: "PF / ESI / PT / detailed tax computation focus",
  },
  minimal: {
    title: "Minimal",
    blurb: "Clean net-focused slip",
  },
};

export const DEFAULT_SECTION_ORDER = SECTION_BLOCKS.map((s) => s.id);

export function normalizeSectionOrder(order) {
  const known = new Set(SECTION_BLOCKS.map((s) => s.id));
  const cleaned = (Array.isArray(order) ? order : []).filter((id) => known.has(id));
  DEFAULT_SECTION_ORDER.forEach((id) => {
    if (!cleaned.includes(id)) cleaned.push(id);
  });
  return cleaned;
}
